export enum KisiKurumTuru{
    sahis="sahis",
    sirket="sirket"
}
export enum KisiKurumTuruLabel{
    sahis="Kişi",
    sirket="Kurum"
}
